import styled, { css } from "styled-components";
import { colorMixin, typographyMixin } from "../../../helpers";
import BaseInputLike from "../InputLike";

export const InputLike = styled(BaseInputLike)`
    cursor: pointer;
`;

export const SelectedOptionWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    align-items: flex-start;
    gap: 4px;
    max-width: 100%;
`;

export const SelectedOption = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 2px 8px;
    background: ${({ theme }) => theme.v2.colors["surface-50"]};
    border-radius: 16px;
    height: 20px;
    overflow: hidden;
    gap: 4px;

    ${typographyMixin("label-x-small-medium")}
    color: ${({ theme }) => theme.v2.colors["text-primary-700"]};
`;

export const DropdownWrapper = styled.div`
    left: 0;
    top: calc(100% + 8px);
    position: absolute;
    max-height: 260px;
    overflow-y: scroll;
    z-index: 3;
    width: -webkit-fill-available;
    display: flex;
    flex-direction: column;
    padding: 4px 0px 8px 0px;

    ${({ theme }) => css`
        color: ${theme.v2.colors["text-primary-1200"]};
        background-color: ${theme.v2.colors["background-primary-base"]};
        border-radius: 4px;
        box-shadow: 0 1px 5px ${theme.v2.colors["border-primary-200"]};
    `}
`;

export const ArrowWrapper = styled.div`
    display: flex;
    cursor: pointer;
    position: absolute;
    right: 12px;
    color: ${({ theme }) => theme.v2.colors["text-primary-800"]};
`;

export const DropdownItem = styled.div<{ isActive?: boolean; subgroup?: boolean }>`
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 8px 12px;
    ${({ onClick }) => onClick && "cursor: pointer;"}
    ${typographyMixin("label-small-regular")}
    color: ${colorMixin("text-primary-1200")};

    :hover {
        background: ${colorMixin("surface-50")};
    }

    ${({ theme, isActive }) =>
        isActive &&
        css`
            background: ${theme.v2.colors["surface-50"]};
        `}
`;

export const SelectWrapper = styled.div`
    position: relative;
`;

export const OptionsGroup = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: start;
    margin: 1px 0;
    border-radius: 0.5em;
    padding: calc(0.5em - 0.15em - 1px);
    background-color: ${colorMixin("background-secondary-600", 0.5)};
`;

export const ClearIconWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    fill: ${({ theme }) => theme.v2.colors["text-primary-600"]};

    ${({ onClick }) =>
        onClick &&
        css`
            cursor: pointer;

            :hover {
                color: ${({ theme }) => theme.v2.colors["text-primary-500"]};
            }
        `}
`;
